import { render, staticRenderFns } from "./StaffCombProperty.vue?vue&type=template&id=74485246&scoped=true&"
import script from "./StaffCombProperty.vue?vue&type=script&lang=ts&"
export * from "./StaffCombProperty.vue?vue&type=script&lang=ts&"
import style0 from "./StaffCombProperty.vue?vue&type=style&index=0&id=74485246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74485246",
  null
  
)

export default component.exports